import {
  Field,
  FieldDescription,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "@repo/ui/ui/field";
import { Textarea } from "@repo/ui/ui/textarea";

import type { DatasourceForm } from "./datasource-new.types";

/** BigQuery-specific credential fields for the datasource form. */
export const BigQueryFields = ({ form }: { form: DatasourceForm }) => (
  <FieldGroup>
    <form.Field name="serviceAccount">
      {(field) => {
        const isInvalid =
          field.state.meta.isTouched && !field.state.meta.isValid;
        return (
          <Field data-invalid={isInvalid}>
            <FieldLabel htmlFor={field.name}>Service account</FieldLabel>
            <Textarea
              id={field.name}
              name={field.name}
              value={field.state.value}
              onBlur={field.handleBlur}
              onChange={(e) => field.handleChange(e.target.value)}
              placeholder={`{
"type": "service_account",
"project_id": "project-id",
"private_key_id": "key-id",
"private_key": "private-key",
"client_email": "service-account-email",
"client_id": "client-id",
"auth_uri": "https://accounts.google.com/o/oauth2/auth",
"token_uri": "https://accounts.google.com/o/oauth2/token",
"auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
"client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/service-account-email"
}`}
              autoComplete="off"
              aria-invalid={isInvalid}
              className="no-scrollbar h-64 resize-none overflow-x-auto whitespace-pre font-mono text-sm"
            />
            {isInvalid && <FieldError errors={field.state.meta.errors} />}
            <FieldDescription>
              You can create a service account credential in your{" "}
              <a
                href="https://console.cloud.google.com/iam-admin/serviceaccounts"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4 hover:text-foreground"
              >
                GCP Console
              </a>
              .
            </FieldDescription>
          </Field>
        );
      }}
    </form.Field>
  </FieldGroup>
);
